import { render, staticRenderFns } from "./SystemPlatConfigPop.vue?vue&type=template&id=ed07fde0&"
import script from "./SystemPlatConfigPop.vue?vue&type=script&lang=js&"
export * from "./SystemPlatConfigPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports